import { UserCircleIcon } from '#assets/ReactSvg.ts';
import { Link } from '#components/atoms/link/Link.tsx';
import { Menu, MenuButton, MenuItem, useMenuStore } from '#components/patterns/menus/menu/index.ts';
import { UpdatesDot } from '#components/patterns/updates/updates-dot/UpdatesDot.tsx';
import { WhatsNewMenuItem } from '#components/patterns/updates/whats-new-menu-item/WhatsNewMenuItem.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { useWhatsNew } from '#global/context/whats-new/useWhatsNew.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import styles from './UserMenu.module.css';

/**
 * {@link UserMenu} displays the logged-in user's email address and a logout button in
 * a menu.
 */
export function UserMenu() {
  const { user, signout } = useAuth();
  const location = useAppLocation();
  const menu = useMenuStore();
  const { hasUnread } = useWhatsNew();
  return (
    <>
      <MenuButton store={menu} className={`menu-button ${styles.UserMenu_button}`}>
        <span className={styles.UserMenu_avatar}>
          <UserCircleIcon width={24} height={24} />
          {/* A marker inside a closed dropdown announces nothing, so it rides on the trigger too */}
          {hasUnread ?
            <UpdatesDot className={styles.UserMenu_dot} />
          : null}
        </span>
        <span>Your account</span>
        {hasUnread ?
          <span className="visually-hidden">(unread notifications)</span>
        : null}
      </MenuButton>
      <Menu store={menu} gutter={8} className="menu-list ml-16">
        <div className={styles.UserMenu_email}>{user?.email}</div>
        <WhatsNewMenuItem />
        {user?.type === 'user' && (
          <MenuItem render={<Link to={'/settings/user'} state={{ from: location }} />}>User settings</MenuItem>
        )}
        <MenuItem onClick={signout}>Logout</MenuItem>
      </Menu>
    </>
  );
}
